import { gql, TypedDocumentNode } from "@apollo/client";

import type {
  BlockedDecisionDetail,
  GetBlockedDecisionsQuery,
  GetBlockedDecisionsQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useFetchQuery } from "src/graphql/utils";
import { toBlockedByDecision } from "src/mappers/blockedDecisions.mappers";

export type { BlockedDecisionDetail };
export type { BlockedDecisionInfo } from "src/mappers/blockedDecisions.mappers";

export const getBlockedDecisionsQuery = gql`
  query GetBlockedDecisions($alertId: ID!) {
    alertDecisions(id: $alertId) {
      code
      blocked
      reason
      details {
        blacklistName
        propertyName
        propertyValue
        status
      }
    }
  }
` as TypedDocumentNode<GetBlockedDecisionsQuery, GetBlockedDecisionsQueryVariables>;

export type UseBlockedDecisionsQueryReturn = {
  data: ReturnType<typeof toBlockedByDecision> | undefined;
  loading: boolean;
  error: Error | undefined;
};

/**
 * Returns blocked state per decision for the given alert.
 */
export function useBlockedDecisionsQuery(
  alertId: string | undefined
): UseBlockedDecisionsQueryReturn {
  const result = useFetchQuery(getBlockedDecisionsQuery, {
    queryOptions: {
      variables: { alertId: alertId ?? "" },
      skip: !alertId,
    },
    toData: (data) => toBlockedByDecision(data?.alertDecisions ?? []),
    isEmpty: (data) => !data,
    uiErrors: { fetchError: "FETCH-ALERTS-ERROR" },
  });
  return {
    data: result.data,
    loading: result.loading,
    error: (result.error as Error | null) ?? undefined,
  };
}
